import { render, staticRenderFns } from "./PacsTable.vue?vue&type=template&id=77f6b937"
import script from "./PacsTable.vue?vue&type=script&lang=js"
export * from "./PacsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports